<template>
  <div class="form-horizontal">
    <div class="margin-top-20 margin-bottom-20">
      <div class="row">
        <div class="col-md-3">邮箱地址</div>
        <div class="col-md-6">
          <input type="text" class="form-control" v-model="inputEmail" />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 control-label">图形验证码</label>
      <div class="col-md-6">
        <input
          type="text"
          class="form-control"
          placeholder="请输入图形验证码"
          aria-describedby="basic-addon1"
          v-model="captcha"
        />
      </div>
      <div class="col-md-3">
        <!--          <button type="submit" class="btn btn-default form-control sub" @click="getRandomImage" v-if="!imageCode">获取验证码</button>-->
        <p
          style="margin-top: 10px; cursor: pointer"
          @click="getRandomImage"
          v-if="!imageCode"
        >
          点击获取
        </p>
        <img :src="imageCode" v-else @click="getRandomImage" />
      </div>
    </div>
    <div class="explain">
      <span
        >收到验证邮件后，点击邮件中的链接绑定该邮箱，如未收到，请点击重新发送或查看垃圾箱。</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeBindEmail",
  props: [""],
  data: function () {
    return {
      sendEmailDisabled: false,
      smsMessage: `发送验证邮件`,
      inputEmail: ``,
      randomCode: null,
      showFlag: false,
      smsDisabled: false,
      captcha: ``,
      imageCode: `/static/images/checkcode.png`,
      timer: null,
    };
  },
  created() {},
  computed: {},
  mounted() {
    const number = parseInt(Math.random(1) * Math.pow(10, 10));
    this.randomCode = number;
    this.getRandomImage();
  },
  methods: {

    verificationImage() {
      var myreg = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!this.inputEmail) {
        this.$message.warning("请输入邮箱");
        return;
      }
      if (!myreg.test(this.inputEmail)) {
        this.$message.warning("邮箱格式不正确！");
        return;
      } else if (!this.captcha) {
        this.$message.warning("请输入图形验证码");
        return
      } else {
        this.$emit('toggle-modal', {visable: true, Loading: true});
        this.sendSms()
      }
    },
    // 获取图形验证码
    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        this.imageCode = res.result;
      });
    },
    sendSms() {
      this.axios
        .get(`/biz/user/email/verify/code`, {
          params: {
            captcha: this.captcha,
            checkKey: this.randomCode,
            email: this.inputEmail,
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("发送成功");
            this.$emit('toggle-modal', {visable: false, Loading: false});
            this.countdown(120);
          }
        })
        .catch(() => {
          this.getRandomImage();
          this.$emit('toggle-modal', {visable: true, Loading: false});
        });
    },
    countdown(index) {
      let countdownData = index;
      this.sendEmailDisabled = true;

      if (this.timer) {
        console.log(this.timer);
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`;
          countdownData--;
        } else {
          this.smsMessage = `发送验证码`;
          this.sendEmailDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  }, // methods end
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.border-none {
  border: 0;
}
  .form-horizontal{
    background:#fff;
  }
  .line {
    border-top: 1px solid #efefef;
  }



    .col-md-2 {
      margin-top: 8px;
      padding-right: 6px;
    }

  .row {
    width: 500px;
    margin: 0 auto;
  }

  .col-md-4 {
    padding-right: 0;
  }

  label {
    margin-top: 10px;
  }

  .explain {
    margin-top: 16px;
    background-color: #fffbed;
    border: 1px solid #f9efd3;
    padding: 10px 20px 10px;
    line-height: 24px;
  }

  .btn-confirm {
    width: 108px;
    height: 34px;
    background: $bgColor;
    color: #fff;
  }

  .verification {
    background: #fff
    border: 1px solid #ccc;
    white-space: nowrap;
    padding: 6px 20px;
    min-width: 68px;
    border-radius: 3px;
  }

  .tips {
    font-size: 13px;
    color: #f00;
  }

  .image-random {
    display: flex;
  }

  .image-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ChangeBindEmail.vue